// Palette condivisa da dashboard pubblicazione e statistiche degli articoli.
export const PUBLISH_STATUS_COLORS = {
  SI: "#2e7d32",
  "DA CONTROLLARE": "#a5d6a7",
  NO: "#cfd8dc",
  PROBLEMA: "#ef6c00",
  "NON PUBBLICARE": "#424242",
  ALTRO: "#607d8b",
};

export const PUBBLICATO_ID_TO_LABEL = {
  1: "DA CONTROLLARE",
  180979: "SI",
  180978: "NO",
  201530: "NON PUBBLICARE",
  284425: "PROBLEMA",
};

export function publicationLabelFromValue(value) {
  const selected = PUBBLICATO_ID_TO_LABEL[String(value?.valueId ?? "").trim()];
  if (selected) return selected;
  const description = String(value?.valueDesc ?? "").trim().toUpperCase();
  return description || null;
}

export function publicationSelectionFromValue(value) {
  const label = publicationLabelFromValue(value);
  const selectedId = Object.keys(PUBBLICATO_ID_TO_LABEL).find(id => PUBBLICATO_ID_TO_LABEL[id] === label);
  return selectedId ?? value?.valueId ?? value?.valueDesc ?? "";
}

// Tutti gli stati usano valueId; 1 è un ID Domino, non PrestaShop.
export function publicationValueFromSelection(value) {
  if (value === "" || value === null || value === undefined) return { valueId: null };
  // Un catalogo API non ancora aggiornato espone ancora l'etichetta come valore dell'opzione.
  const label = String(value).trim().toUpperCase();
  const idFromLabel = Object.keys(PUBBLICATO_ID_TO_LABEL).find(id => PUBBLICATO_ID_TO_LABEL[id] === label);
  return { valueId: Number(idFromLabel ?? value) };
}
